import { Spinner } from '@repo/design-system-kit';
import styles from './loading.module.css';

export function KycLoading() {
  return (
    <main className={styles.loadingState}>
      <Spinner size="large" />
    </main>
  );
}
